module.exports = [
    '$analytics', 
    '$uibModal', 
    customsRulingsModal
];

function customsRulingsModal(
    $analytics, 
    $uibModal
) {

    var modal = {
        goodsCode: null,
        searchQuery: null,
        show: showModal
    };

    customsRulingsModalController.$inject = [
        '$uibModalInstance',
        'common', 
        'crossDataService', 
        'goodsCode', 
        'searchQuery',
    ];

    function customsRulingsModalController(
        $uibModalInstance, 
        common,
        crossDataService, 
        goodsCode, 
        searchQuery
    ) {

        var vm = {
            $onInit: attached,
            cancel: cancel,
            changeActiveRuling: changeActiveRuling,
            service: crossDataService,
        };

        return vm;

        function attached() {
            // crossDataService.clearActiveRuling();
            crossDataService.resetFilter();
            crossDataService.filter.goodsCode = common.formatting.removeTrailingZeros(goodsCode);
            crossDataService.filter.subjectQuery = searchQuery;
            crossDataService.loadNewRulings();
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function changeActiveRuling(rulingNumber) {
            crossDataService.changeActiveRuling(rulingNumber);
        }

    }

    function showModal(goodsCode, searchQuery) {
        $analytics.eventTrack('open-modal-cross', { category: 'cross' });
        if (goodsCode) {
            modal.goodsCode = goodsCode;
        }
        if (searchQuery) {
            modal.searchQuery = searchQuery;
        }

        return $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: customsRulingsModalController,
            controllerAs: '$ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                goodsCode: function () {
                    return modal.goodsCode;
                },
                searchQuery: function () {
                    return modal.searchQuery;
                }
            },
            size: 'lg',
            templateUrl: 'cross/modals/customs-rulings-modal.html',
            windowClass: 'modal-bti'
        }).result.catch(function (res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
                throw res;
            }
        });
    }

    return modal;
}